var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"word-break"},[_vm._l((_vm.lines),function(line,index){return [_vm._v(" "+_vm._s(line)),(index < _vm.lines.length - 1)?_c('br',{key:index}):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }